module.exports = __webpack_public_path__ + "img/alert.6f563596.png";